module.exports = __webpack_public_path__ + "images/icons/icon-locations-90ce9476.svg";